<template>
  <b-modal
    id="modal-discount"
    :body-bg-variant="bodyBgVariant"
    :modal-class="popupPrice+' '+popupPriceSidebar+' '+'popup-price-btn'"
    no-close-on-backdrop
    no-fade
  >
    <template
      slot="modal-header"
      slot-scope="{ close }"
    >
      <b-button
        variant="outline-light"
        @click="close()"
      >
        {{ $t("discountpopup.cancel") }}
      </b-button>
      <h5>
        {{ $t("discountpopup.discount") }}
      </h5>
    </template>

    <div class="pin-win discount-modal">
      <span
        v-if="discount.type === 1"
      >
        {{ parseFloat(discount.val).toFixed(1) }} %
      </span>
      <span
        v-if="discount.type === 2"
      >
        {{ currency }} {{ parseFloat(discount.val).toFixed(2) }}
      </span>
      <b-button
        v-if="discount.type === 1"
        variant="primary"
        @click="$emit('change-type')"
      >
        {{ $t("discountpopup.percent-off") }}
      </b-button>
      <b-button
        v-if="discount.type === 2"
        variant="primary"
        @click="$emit('change-type')"
      >
        {{ $t("discountpopup.currency-off") }}
      </b-button>
    </div>

    <div class="pin-keyboard text-center my-0">
      <ul class="pin-keyboard-list">
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 1)"
          >1</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 2)"
          >2</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 3)"
          >3</span>
        </li>

        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 4)"
          >4</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 5)"
          >5</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 6)"
          >6</span>
        </li>

        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 7)"
          >7</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 8)"
          >8</span>
        </li>
        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 9)"
          >9</span>
        </li>

        <li>
          <span
            class="pin-key pin-key_call"
            @click="$emit('type-digit', 'C')"
          >C</span>
        </li>

        <li>
          <span
            class="pin-key"
            @click="$emit('type-digit', 0)"
          >0</span>
        </li>

        <li>
          <span
            class="pin-key bg-primary"
            disabled="disabled"
            @click="$emit('save')"
          >
            <svg class="icon icon-icon-check">
              <use xlink:href="#icon-icon-check" />
            </svg>
          </span>
        </li>
      </ul>
    </div>

    <div
      slot="modal-footer"
      class="w-100"
    >
      <h5>
        {{ $t("discountpopup.discounts") }}
      </h5>

      <ul class="list-unstyled ">
        <li
          v-for="(discountItem, index) in allDiscounts"
          :key="index"
        >
          <span
            class="discount-item"
            @click="$emit('set-predefined', index)"
          >
            {{ discountItem.name }}
          </span>
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "OrderDiscountModal",
  props: {
    // Live discount draft object (val/raw/type/index/changed) owned by the
    // parent view; mutated in place by the parent's typeDiscount/etc handlers.
    discount: {
      type: Object,
      default: () => ({ val: "", changed: false, type: 1 }),
    },
    currency: {
      type: String,
      default: "",
    },
    allDiscounts: {
      type: Array,
      default: () => [],
    },
    bodyBgVariant: {
      type: String,
      default: "light",
    },
    popupPrice: {
      type: [String, Array],
      default: () => ["popup-price"],
    },
    popupPriceSidebar: {
      type: [String, Array],
      default: () => ["popup-price-sidebar"],
    },
  },
};
</script>
